<template>
    <path style="fill-rule:evenodd;clip-rule:evenodd;fill:#281F1F;" d="M71.6,39.8c-0.1-0.6-0.3-1.1-0.5-1.7c-0.4-0.9-1-1.8-1.7-2.5
	c-0.7-0.7-1.6-1.3-2.5-1.7c-1-0.4-2-0.6-3.1-0.6c-1.1,0-2.1,0.2-3.1,0.6c-0.9,0.4-1.8,1-2.5,1.7c-0.7,0.7-1.3,1.6-1.7,2.5
	c-0.2,0.5-0.4,1.1-0.5,1.7h-4.9c-0.1-0.6-0.3-1.1-0.5-1.7c-0.4-0.9-1-1.8-1.7-2.5c-0.7-0.7-1.6-1.3-2.5-1.7c-1-0.4-2-0.6-3.1-0.6
	c-1.1,0-2.1,0.2-3.1,0.6c-0.9,0.4-1.8,1-2.5,1.7c-0.7,0.7-1.3,1.6-1.7,2.5c-0.2,0.5-0.4,1.1-0.5,1.7h-1.9v1.4h1.7
	c0,1.1,0.2,2.1,0.6,3.1c0.4,0.9,1,1.8,1.7,2.5c0.7,0.7,1.6,1.3,2.5,1.7c1,0.4,2,0.6,3.1,0.6c1.1,0,2.1-0.2,3.1-0.6
	c0.9-0.4,1.8-1,2.5-1.7c0.7-0.7,1.3-1.6,1.7-2.5c0.4-1,0.6-2,0.6-3.1h4.6c0,1.1,0.2,2.1,0.6,3.1c0.4,0.9,1,1.8,1.7,2.5
	c0.7,0.7,1.6,1.3,2.5,1.7c1,0.4,2,0.6,3.1,0.6c1.1,0,2.1-0.2,3.1-0.6c0.9-0.4,1.8-1,2.5-1.7c0.7-0.7,1.3-1.6,1.7-2.5
	c0.4-1,0.6-2,0.6-3.1h2v-1.4H71.6z M43.4,48.3c-3.9,0-7.2-3.2-7.2-7.2c0-3.9,3.2-7.2,7.2-7.2c3.9,0,7.2,3.2,7.2,7.2
	C50.6,45.1,47.3,48.3,43.4,48.3z M63.8,48.3c-3.9,0-7.2-3.2-7.2-7.2c0-3.9,3.2-7.2,7.2-7.2s7.2,3.2,7.2,7.2
	C71,45.1,67.8,48.3,63.8,48.3z"/>
</template>

<script>
    export default {
        name: 'Eye4',
    }
</script>
